import { withRouter, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import React, { useEffect, useState, Fragment } from 'react';

import {
  Grid,
  Typography,
  LinearProgress,
  Box,
  Avatar
} from '@mui/material';

import { FiStar } from 'react-icons/fi';

import listaProdutosExclusivos from "../../actions/produtos/lista-produtos-exclusivos";
import Products from "../../components/Products";
import { useSelector, useDispatch } from 'react-redux';
import Actions from "../../constants/Actions";
import useResponsive from '../../utils/useResponsive';

// actions
import listaFiltrarPorLinha from '../../actions/produtos/lista-filtrar-por-linha'
import listaPesquisarPorLinha from '../../actions/produtos/lista-pesquisar-por-linha'
import listaAtributosPorLinha from "../../actions/produtos/lista-atributos-por-linha"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function ExclusivoPage() {

  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const loading = useSelector(state => state.loading);
  const [value, setValue] = React.useState(0);

  const [grupoInput, setGrupoInput] = useState([]);
  const [grupo, setGrupo] = useState([]);

  const [grade, setGrade] = useState([]);
  const [gradeInput, setGradeInput] = useState([]);

  const [griffe, setGriffe] = useState([]);
  const [griffeInput, setGriffeInput] = useState([]);

  const [filial, setFilial] = useState([]);

  const [subgrupo, setSubgrupo] = useState([]);
  const [subgrupoInput, setSubgrupoInput] = useState([]);

  const [categoria, setCategoria] = useState([]);
  const [categoriaInput, setCategoriaInput] = useState([]);

  const [slidePreco, setSlidePreco] = useState([0, 2000]);
  const [inputValue, setInputValue] = React.useState('');

  const [grupos, setGrupos] = useState([]);
  const [subgrupos, setSubgrupos] = useState([]);
  const [griffes, setGriffes] = useState([]);

  const [pathOld, setPathOld] = useState("");

  const isDesktop = useResponsive('up', 'md');

  //params
  const { exclusivo } = useParams();

  const handleChangeSlidePreco = (event, newValue) => {
    setSlidePreco(newValue);
  };

  function valuetext(value) {
    return `${value}°C`;
  }

  const handleGrupo = (array) => {
    setPathOld(exclusivo);
    setGrupoInput(array);
    if (array !== null) {
      setGrupo(array.map((item) => item.value))
    }
  };

  const handleSubgrupo = (array) => {
    setPathOld(exclusivo);
    setSubgrupoInput(array);
    if (grupo !== null) {
      setSubgrupo(array.map((item) => item.value))
    }
  };

  const handleGriffe = (array) => {
    setPathOld(exclusivo);
    setGriffeInput(array);
    if (grupo !== null) {
      setGriffe(array.map((item) => item.value))
    }
  };

  const handleGrade = (array) => {
    setPathOld(exclusivo);
    setGradeInput(array);
    if (grupo !== null) {
      setGrade(array.map((item) => item.value))
    }
  };

  const handleCategoria = (array) => {
    setPathOld(exclusivo);
    setCategoriaInput(array);
    if (grupo !== null) {
      setCategoria(array.map((item) => item.value))
    }
  };

  const handleFiltrarProdutos = () => {
    dispatch({ type: Actions.LOADING, loading: true })
    listaFiltrarPorLinha({ grupo, subgrupo, grade, filial, griffe, linha: exclusivo, preco: slidePreco }).then(res => {
      dispatch({ type: Actions.SET_TODOS_PRODUTOS, products: res.data.produtos });
      setOpen(false);
      dispatch({ type: Actions.LOADING, loading: false })
    }).catch(err => console.log(err));
  };

  const handleBuscarAtributosPorLinha = atributo => {
    listaAtributosPorLinha({ atributo: atributo, linha: exclusivo, }).then(res => {
      if (atributo === 'grupo_produto') {
        setGrupos(res.data.atributos);
      } else if (atributo === 'subgrupo_produto') {
        setSubgrupos(res.data.atributos);
      } else if (atributo === 'griffe') {
        setGriffes(res.data.atributos);
      }
    }).catch(err => console.log(err));
  };

  useEffect(() => {
    if (pathOld !== exclusivo) {
      setSubgrupo([]);
      setSubgrupoInput([]);
      setGriffe([]);
      setGriffeInput([]);
      setGrupo([]);
      setGrupoInput([]);
    }
  }, [exclusivo]);

  useEffect(() => {
    dispatch({ type: Actions.LOADING, loading: true })
    listaProdutosExclusivos({ atributo: exclusivo }).then(res => {
      if (res.data.produtos.length > 0) {
        dispatch({ type: Actions.SET_TODOS_PRODUTOS, products: res.data.produtos });
        dispatch({ type: Actions.LOADING, loading: false })
      }
      dispatch({ type: Actions.LOADING, loading: false })
    }).catch(err => console.log(err));
  }, []);

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {loading === true ? (
        <LinearProgress sx={{ '& .MuiLinearProgress-bar': { bgcolor: '#1a1a2e' } }} />
      ) : (
        <>
          {/* Header */}
          {isDesktop && (
            <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
              <Box sx={{ py: 3, px: { xs: 2, md: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                    <FiStar size={18} />
                  </Avatar>
                  <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
                      Exclusivos PDV
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, textTransform: 'capitalize', mt: 0.5 }}>
                      {exclusivo}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {/* Content */}
          <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
            <Grid container>
              <Grid item md={12} xs={12}>
                <Products style={{ marginTop: 50 }} />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Box>
  )
}
export default withRouter(ExclusivoPage)
